import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Popover from '../Popover/Popover.js';
import { TOOLTIP_ARROW_SVG_SIZE } from '../Popover/Arrow.js';

const TOOLTIP_PROPS = {
  placement: ['top', 'top-start', 'top-end', 'right', 'right-start', 'right-end', 'bottom', 'bottom-start', 'bottom-end', 'left', 'left-start', 'left-end', 'auto', 'auto-start', 'auto-end'],
  // TODO: Maybe add wrapper to convert BP intents (primary->info, danger->error) with warning message
  intent: ['success', 'error', 'warning', 'info', 'default'],
  positioningStrategy: ['absolute', 'fixed']
};
const BASE_CLASS = 'nui-tooltip';
const tooltipPropTypes = {
  /** element which will trigger the tooltip and be it's target */
  children: PropTypes.node,
  /** optional classes for the target wrapper */
  className: PropTypes.string,
  /** the content displayed inside the tooltip */
  content: PropTypes.node,
  /** initial opened state when uncontrolled */
  defaultIsOpen: PropTypes.bool,
  /** prevents from showing */
  disabled: PropTypes.bool,
  /** visual intent color to apply to element */
  intent: PropTypes.oneOf(TOOLTIP_PROPS.intent),
  /** puts tooltip in controlled mode when passed */
  isOpen: PropTypes.bool,
  /** will not show arrow and uses subtler animation */
  minimal: PropTypes.bool,
  /** user interaction callback when in controlled mode */
  onInteraction: PropTypes.func,
  /** placement relative to the target at which the tooltip should appear */
  placement: PropTypes.oneOf(TOOLTIP_PROPS.placement),
  /** optional classes for the popover element */
  popoverClassName: PropTypes.string,
  /** Popper [positioning strategy](https://popper.js.org/docs/v2/constructors/#strategy) */
  positioningStrategy: PropTypes.oneOf(TOOLTIP_PROPS.positioningStrategy),
  /** HTML tag name for the target element */
  targetTagName: PropTypes.oneOf(['span', 'div']),
  /** overrides for Popper.js modifiers */
  modifiers: PropTypes.shape({})
};
/**
 * Lightweight popover for showing additional information during hover interactions.
 */
function Tooltip({
  children,
  intent = 'default',
  popoverClassName,
  modifiers,
  ...rest
}) {
  const classes = cx(BASE_CLASS, intent && `${BASE_CLASS}--${intent}`, popoverClassName);
  return /*#__PURE__*/React__default.createElement(Popover, _extends({
    hoverCloseDelay: 0,
    hoverOpenDelay: 100,
    transitionDuration: 100,
    lazy: true,
    popoverClassName: classes
  }, rest, {
    interactionKind: "hover-target",
    modifiers: {
      offset: {
        options: {
          offset: [0, TOOLTIP_ARROW_SVG_SIZE / 2]
        }
      },
      arrow: {
        options: {
          padding: 2
        }
      },
      ...modifiers
    },
    canEscapeKeyClose: false,
    enforceFocus: false
  }), children);
}
Tooltip.propTypes = tooltipPropTypes;
Tooltip.displayName = 'NuiTooltip';

export { TOOLTIP_PROPS, Tooltip as default };
